export type GovernanceArea = "truth" | "focus" | "promise";

const AREAS: Array<{ id: GovernanceArea; label: string }> = [
  { id: "truth", label: "事实" },
  { id: "focus", label: "聚焦" },
  { id: "promise", label: "承诺" },
];

export function GovernanceTabs({
  area,
  onChange,
}: {
  area: GovernanceArea;
  onChange: (area: GovernanceArea) => void;
}) {
  return (
    <nav className="governance-tabs" aria-label="治理模块">
      {AREAS.map((item) => (
        <button
          key={item.id}
          type="button"
          className={area === item.id ? "is-selected" : ""}
          aria-current={area === item.id ? "page" : undefined}
          onClick={() => onChange(item.id)}
        >
          {item.label}
        </button>
      ))}
    </nav>
  );
}
